module.exports = __webpack_public_path__ + "static/media/silkycloud-red-2.9d42df66.png";